import { combineReducers } from 'redux'

import { previewInvoiceSlice } from 'common/billing/redux/previewInvoice'

import { eMandateSlice } from '../components/EmandateModal/eMandateSlice'
import { reducer as ukraineReliefProgram } from '../components/UkraineReliefProgramModal/ukraineReliefProgramSlice'
import wallet from '../wallet/walletSlices'

import { billingInfoSlice } from './billingInfo'
import { billingProSlice } from './billingPro'
import { billingStateSlice } from './billingState'
import { blockedProModalSlice } from './blockedProModal'
import { cancelAddOnModalSlice } from './cancelAddOnModal'
import { cancellationSlice } from './cancellation'
import { chargesSlice } from './charges'
import { disableProductModalSlice } from './disableProductModal'
import { emailStatsSlice } from './emailStats'
import { invoicesSlice } from './invoices'
import { migrateFreeUsersToNewBillingModalSlice } from './migrateFreeUsersToNewBillingModal'
import { migrationConsentSlice } from './migrationConsent'
import { nextActionModalSlice } from './nextActionModal'
import { overagesManagingModalSlice } from './overagesManagingModal'
import { paymentCardRenewalModalSlice } from './paymentCardRenewalModal'
import { smsStatsSlice } from './smsStats'
import { stripeCheckoutSlice } from './stripeCheckout'
import { subscriptionSuccessModalSlice } from './subscriptionSuccessModal'
import { taxFormSlice } from './taxForm'
import { tiersSlice } from './tiers'

export default combineReducers({
  invoices: invoicesSlice.reducer,
  charges: chargesSlice.reducer,
  wallet,
  [stripeCheckoutSlice.name]: stripeCheckoutSlice.reducer,
  ukraineReliefProgram,
  [eMandateSlice.name]: eMandateSlice.reducer,
  [disableProductModalSlice.name]: disableProductModalSlice.reducer,
  [nextActionModalSlice.name]: nextActionModalSlice.reducer,
  [blockedProModalSlice.name]: blockedProModalSlice.reducer,
  [cancellationSlice.name]: cancellationSlice.reducer,
  [tiersSlice.name]: tiersSlice.reducer,
  [billingInfoSlice.name]: billingInfoSlice.reducer,
  [cancelAddOnModalSlice.name]: cancelAddOnModalSlice.reducer,
  [smsStatsSlice.name]: smsStatsSlice.reducer,
  [emailStatsSlice.name]: emailStatsSlice.reducer,
  [billingProSlice.name]: billingProSlice.reducer,
  [paymentCardRenewalModalSlice.name]: paymentCardRenewalModalSlice.reducer,
  [billingStateSlice.name]: billingStateSlice.reducer,
  [taxFormSlice.name]: taxFormSlice.reducer,
  [previewInvoiceSlice.name]: previewInvoiceSlice.reducer,
  [overagesManagingModalSlice.name]: overagesManagingModalSlice.reducer,
  [migrateFreeUsersToNewBillingModalSlice.name]: migrateFreeUsersToNewBillingModalSlice.reducer,
  [migrationConsentSlice.name]: migrationConsentSlice.reducer,
  [subscriptionSuccessModalSlice.name]: subscriptionSuccessModalSlice.reducer,
})
